import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
// import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
// import { getADVersionForExecution, getScenarioCollectionForListing, updateScenarioCollectionForListing } from '../../components/UserFunctions';
import { getScenarioCollectionForListing } from '../../components/UserFunctions';
// import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap"
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';
// import DeleteCloseLoopScenarioGroupModal from './DeleteCloseLoopScenarioGroupModal';
import { addBaseScenarioCollectionFromAPI, updateBaseScenarioInfo, updateInnerBaseScenarioInfo } from '../../actions/closeLoop/baseScenarioCollectionActionCloseLoop';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
// import PopupModal from '../PopupModal';
import Pagination from './../Pagination';
import ProgressBar from './scenarioGroupProgressBar';
import BaseCart from '../../components/closedLoop/BaseCartComponent'
import BaseScenarioPopup from '../../components/closedLoop/AddBaseScenarioPopup'
import { addBaseScenarioToCart, getADClientList } from '../../actions/closeLoop/addToCartActionCloseLoop'
import { Link } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

class CloseLoopBaseScenarioCollectionDataTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scenario: [],
      scenario_popup: false,
      base_sc: "",
      loading: false,
      loadingTip: "loading ..."
    };
    this.updateScenarioCount = this.updateScenarioCount.bind(this)
    this.openPopupModal = this.openPopupModal.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
    this.toggleLoading = this.toggleLoading.bind(this)

  }

  togglePopup() {
    this.setState({
      scenario_popup: false,
    })
  }

  toggleLoading() {
    this.setState({
      loading: !this.state.loading,
    })
  }

  stopLoading() {
    this.setState({
      loading: false,
    })
  }

  updateScenarioCount() {
    let scenario_count = 0
    const scenarios = []

    console.log(this.props.baseScenarioCollectionData)

    for (let i = 0; i < this.props.baseScenarioCollectionData.length; i++) {
      for (let j = 0; j < this.props.baseScenarioCollectionData[i].base_scenario_list.length; j++) {
        if (this.props.baseScenarioCollectionData[i].base_scenario_list[j].isChecked === true) {
          scenario_count = scenario_count + this.props.baseScenarioCollectionData[i].base_scenario_list[j].base_variation_count
          scenarios.push(this.props.baseScenarioCollectionData[i].base_scenario_list[j].base_scenario_name)

        }
      }
    }
    const obj = {
      count: scenario_count - 1,
      items: scenarios
    }
    this.props.addScenarioToCart(obj)

  }
  openPopupModal() {
    this.setState({
      scenario_popup: !this.state.scenario_popup
    })
  }
  componentDidUpdate() {
    this.updateScenarioCount()
  }
  componentDidMount() {
    getScenarioCollectionForListing().then(res => {
      console.log("res-->", res)
      if (res.data) {
        this.props.fetchBaseScenario(res);
        this.setState({scenario: res.data});
        // this.state.scenario = res.data
        let base_scenario_info_array = this.state.scenario;
        for (let i = 0; i < base_scenario_info_array.length; i++) {
          base_scenario_info_array[i]["isChecked"] = false
          for (let j = 0; j < base_scenario_info_array[i].base_scenario_list.length; j++) {
            base_scenario_info_array[i].base_scenario_list[j]["isChecked"] = false
          }
        }
        console.log(this.state.scenario)

      } else {
        this.props.fetchBaseScenario({ data: [], current_page: 0, pages: [] });

      }
    })
  }

  handleCheckbox = (event) => {
    // var checkBox = document.getElementById("myCheck");
    const value = event.target.value;
    const checked_value = event.target.checked;
    this.props.updateScenario(value, checked_value)
  }

  innerHandleCheckbox = (event) => {
    // var checkBox = document.getElementById("innerCheck");
    const value = event.target.value;
    const checked_value = event.target.checked;
    this.props.updateScenarioList(value, checked_value)
    this.updateScenarioCount()

  }

  render() {
    const baseUrl = "data:image/png;base64,";
    const customStyles = {
      rows: {
        style: {
          minHeight: '72px',
          backgroundColor: "#C7C9FF",
        }
      },
      headCells: {
        style: {
          fontSize: "1rem",
          backgroundColor: "white",
          padding: ".75rem",
          verticalAlign: "top",
          borderTop: "1px solid #e9ecef",
          borderBottom: "5px solid #753DFF",
          justifyContent: "center"
        },
      },
      cells: {
        style: {
          fontSize: "1rem",
          textAlign: "center",
          verticalAlign: "top",
          borderTop: "5px solid white",
          justifyContent: "center"
        },
      },
    };

    const customExpandableStyles = {
      rows: {
        style: {
          minHeight: '72px',
        }
      },
      headCells: {
        style: {
          fontSize: "1rem",
          backgroundColor: "white",
          padding: ".75rem",
          verticalAlign: "top",
          borderTop: "1px solid #e9ecef",
          borderBottom: "3px solid #753DFF",
          justifyContent: "center"
        },
      },
      cells: {
        style: {
          textAlign: "center",
          verticalAlign: "top",
          borderTop: "5px solid white",
          justifyContent: "center"
        },
      }
    };
    const columns =
      [{
        name: 'Base Scenario Name',
        selector: 'base_scenario_name',
        sortable: true,
        cell: row => <div style={{ flexWrap: 'wrap' }}>{row.master_base_scenario_name}</div>
      },
      {
        name: 'Base Scenario UUID',
        selector: 'base_scenario_uuid',
        sortable: true,
        cell: row => <div style={{ flexWrap: 'wrap' }}>{row.master_base_scenario_uuid}</div>
      },
      {
        name: 'Base Scenario Count',
        selector: 'base_scenario_count',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.master_base_scenario_count}</div>
      },
      {
        name: 'Variation Count',
        selector: 'variation_count',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.variation_count}</div>
      },
      {
        name: 'Updated At',
        selector: 'data_updated_at',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.updated_at}</div>
      },
      {
        name: 'Base Select Scenario',
        selector: 'data_updated_at',
        cell: row => <div style={{ alignContent: "center" }}>
          <input onClick={this.handleCheckbox} type="checkbox" id="myCheck" value={row.master_base_scenario_name}
            className="form-check-input" checked={row.isChecked} />{" "}  </div>
      }
      ];

    const scn_columns =
      [{
        name: 'Base Scenario Name',
        selector: 'base_scenario_name',
        sortable: true,
        cell: row => <div>{row.base_scenario_name}</div>
      },
      {
        name: 'Base Scenario Description',
        selector: 'base_scenario_description',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.base_scenario_description}</div>,
        grow: 3
      },
      {
        name: 'Base Scenario Representation',
        selector: 'base_scenario_representation',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}><img src={`${baseUrl}${row.base_scenario_representation.replace(/['"]+/g, '')}`}
          alt=""
          style={{ cursor: 'pointer' }}
          width="150"
          height="100"
        ></img></div>,
        grow: 3

      },
      {
        name: 'Base Scenario UUID',
        selector: 'base_scenario_uuid',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.base_scenario_uuid}</div>
      },
      {
        name: 'Base Variation Count',
        selector: 'base_variation_count',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.base_variation_count}</div>
      },
      {
        name: 'Updated At',
        selector: 'updated_at',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.updated_at}</div>
      },
      {
        name: 'Select Scenario',
        selector: 'data_updated_at',
        cell: row => <div style={{ alignContent: "center" }}>
          <input onClick={this.innerHandleCheckbox} type="checkbox" id="innerCheck" value={row.base_scenario_name}
            className="form-check-input-inner" checked={row.isChecked} />
        </div>
      },
      ];
    const data = this.props.baseScenarioCollectionData
    // const scn_list = data.base_scenario_list
    // const scn_data = {
    //   scn_columns,
    //   scn_list
    // }
    const ExpandableComponent = ({ data }) => <DataTable data={data.base_scenario_list} columns={scn_columns} customStyles={customExpandableStyles} />;

    // const tableData = {
    //   columns,
    //   data,
    // };
    console.log("details", this.props.baseScenarioCollectionData)

    return (
      <Spin spinning={this.state.loading} tip={this.state.loadingTip}>
      <div className="container-fluid">
        <Breadcrumb>
          <Breadcrumb.Item href="">
            <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item href="">
            <Link to='/welcome'>Welcome</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="" > <Link to='/close_loop'>Close loop</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/close_loop_scenario_group" active >
            Base Scenario Collection
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className="row">
          <div className="col mt-5 mx-auto">
            <div className="card" style={{ backgroundColor: "white" }}>
              <div className="card">
                <div>
                  <div style={{ backgroundColor: "#757AF7" }}>
                    <div className="row">

                      <div className="col-md-6">
                        <h3 className="card-header" style={{ color: "white", fontSize: "100% !important", backgroundColor: "#757AF7" }}>
                          Base Scenario Collection
                        </h3>

                      </div>
                      <div className="col-md-6" style={{ paddingLeft: "24rem", paddingTop: "1%" }}>
                        <div style={{ textAlign: "center" }}>
                          <button onClick={this.openPopupModal} style={{ backgroundColor: "Transparent", outline: "None", border: "None", float: "right" }}><BaseCart /></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table">

                <div className="card-body">
                  <DataTable
                    className="dataTables_wrapper"
                    columns={columns}
                    customStyles={customStyles}
                    data={data}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    //pagination
                    expandableRows
                    setFilter
                    expandableRowsComponent={<ExpandableComponent />}
                  >
                  </DataTable>
                </div>
                <div>
                  {this.state.scenario_popup ? <BaseScenarioPopup closePopup={this.togglePopup.bind(this)} useHistory={this.props} loading={this.toggleLoading.bind(this)}/> : undefined}
                  {this.props.baseScenarioCollectionData.length > 0 ?
                    <Pagination
                      currentPage={this.props.currentPage}
                      pages={this.props.pages}
                      getApiInfo={getScenarioCollectionForListing}
                      action={addBaseScenarioCollectionFromAPI}
                    />
                    : undefined}
                  <ProgressBar popup ={this.state.loading} loading={this.stopLoading.bind(this)}/>
                </div>
              </div>
            </div>

          </div>



        </div>


      </div>
      </Spin>
    )
  }
}
CloseLoopBaseScenarioCollectionDataTable.propTypes = {
  dispatch: PropTypes.string,
  baseScenarioCollectionData: PropTypes.string,
  currentPage: [],
  pages: [],
}
CloseLoopBaseScenarioCollectionDataTable.defaultProps = {
  dispatch: [],
  baseScenarioCollectionData: [],
  currentPage: [],
  pages: [],
}

const mapStateToProps = (state) => {
  return {
    baseScenarioCollectionData: state.close_loop_baseScenarioCollection.baseScenarioCollection,
    currentPage: state.close_loop_baseScenarioCollection.currentPage,
    pages: state.close_loop_baseScenarioCollection.pages
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateScenario: (value, checked_value) => dispatch(updateBaseScenarioInfo(value, checked_value)),
  fetchBaseScenario: (res) => dispatch(addBaseScenarioCollectionFromAPI(res)),
  updateScenarioList: (value, checked_value) => dispatch(updateInnerBaseScenarioInfo(value, checked_value)),
  addScenarioToCart: (data) => dispatch(addBaseScenarioToCart(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(CloseLoopBaseScenarioCollectionDataTable);
